import { render, staticRenderFns } from "./WaterLeakageIsProfessionalResponsibleQuestion.vue?vue&type=template&id=73c27dcf"
import script from "./WaterLeakageIsProfessionalResponsibleQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageIsProfessionalResponsibleQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports